/**
 * Client-side hardening for free-text fields on the claim “when & where” step.
 *
 * Re-exports shared claim sanitizers with incident-specific names for backward compatibility.
 */

import {
  INCIDENT_ROUGH_LOCATION_MAX_LEN,
  sanitizeClaimFreeText,
  sanitizeClaimIncidentRoughLocation,
  sanitizeClaimIncidentSingleLine,
} from './claimFormTextSanitize'

export {
  INCIDENT_ROUGH_LOCATION_MAX_LEN,
  INCIDENT_STREET_MAX_LEN,
  INCIDENT_SUBURB_MAX_LEN,
} from './claimFormTextSanitize'

/**
 * Sanitizes user-typed incident location text for the when/where step.
 *
 * @param raw - Raw field value
 * @param options.maxLen - Hard maximum length after sanitization
 * @param options.multiline - When true, normalises CRLF to `\n`; when false, newlines become spaces
 */
export function sanitizeIncidentWhenWhereText(
  raw: string,
  options: { maxLen: number; multiline?: boolean }
): string {
  if (options.multiline && options.maxLen === INCIDENT_ROUGH_LOCATION_MAX_LEN) {
    return sanitizeClaimIncidentRoughLocation(raw)
  }
  if (!options.multiline) {
    return sanitizeClaimIncidentSingleLine(raw, options.maxLen)
  }
  return sanitizeClaimFreeText(raw, { maxLen: options.maxLen, multiline: true, allowTab: true })
}
